import { Loader, PageLayout } from '@bharatpe/bharat-ui';
import AppHeader from 'components/atoms/AppHeader';
import React, { useEffect, useState } from 'react';
import BankItemList from '../../../components/molecules/BankItemList';
import history from 'utils/History';
import UpiPoweredBy from 'components/atoms/UpiPoweredBy';
import AllModals from 'containers/UPIContainer/Modals';
import { useUPIUserDetails } from 'Slices/GetUPIUserDetails';
import { logAnalyticsEvent } from 'utils/AnalyticsEvent';
import { useLanguageConfig } from 'Slices/LanguageConfigSlice';
import { customSubScribeBackButton } from 'utils/nativeSupport';

const BankList: React.FC = () => {
	const [loading, setLoading] = useState(false);
	const userDetails = useUPIUserDetails();
	const { languageData } = useLanguageConfig();
	const { user_banks } = userDetails?.data;

	useEffect(() => {
		logAnalyticsEvent({
			trigger_point: 'Page View',
			Product: 'AutoPayUPI',
			Flow: 'Setting',
			Screen: 'Linked_BAs',
			Module: 'Page',
			Action: 'Viewed',
		});
	}, []);

	const onHandleClick = (bankAccountId: string, isPrimary: string, idx: number) => {
		logAnalyticsEvent({
			trigger_point: 'Clicks Bank Account Card',
			Product: 'AutoPayUPI',
			Flow: 'Setting',
			Screen: 'Linked_BAs',
			Module: 'BA_Cards',
			Element: 'CTA',
			Action: 'Tapped',
			accountCard: idx + 1,
			isPrimary: isPrimary,
			ctaType: 'bACard',
		});
		history.push({ pathname: '/account/bank-account-details', search: `?bank-account-id=${bankAccountId}` });
	};

	const backEventAction = () => {
		logAnalyticsEvent({
			trigger_point: `Clicks on Back Button`,
			Product: 'AutoPayUPI',
			Flow: 'Setting',
			Screen: 'Linked_BAs',
			Element: 'back',
			Action: 'Tapped',
			source: 'appHeader',
		});
	};

	useEffect(() => {
		customSubScribeBackButton(() => {
			onBack();
		});
	}, [history]);

	const onBack = () => {
		history.replace({ pathname: '/account/upi-settings' });
	};

	return loading ? (
		<Loader loading />
	) : (
		<PageLayout className="white-background ">
			<>
				<AppHeader
					leftIconAction={onBack}
					title={languageData.LINKED_BANK_ACCOUNTS}
					backEventAction={backEventAction}
				/>
				<div className="mx5 mt6">
					{user_banks?.map((bank: any, idx: number) => (
						<BankItemList
							key={idx}
							bank={bank}
							onHandleClick={(bankAccountId, isPrimary) => onHandleClick(bankAccountId, isPrimary, idx)}
						/>
					))}
				</div>
				<AllModals />
				<div className="upi-powered">
					<UpiPoweredBy />
				</div>
			</>
		</PageLayout>
	);
};
export default BankList;
